import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import AboutSection from './components/AboutSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    const websiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '汗汗漫画',
      url: 'http://sinotruckcn.com/',
      description: '汗汗漫画提供免费韩国漫画在线阅读服务，汇集海量韩漫大全，涵盖热门题材，无需付费即可畅享正版韩漫资源。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'http://sinotruckcn.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    };
    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.textContent = JSON.stringify(websiteSchema);
    document.head.appendChild(script1);

    const orgSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '汗汗漫画',
      url: 'http://sinotruckcn.com/',
      description: '汗汗漫画提供免费韩国漫画在线阅读服务，汇集海量韩漫大全，涵盖热门题材。',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'hello@sinotruckcn.com',
      },
    };
    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.textContent = JSON.stringify(orgSchema);
    document.head.appendChild(script2);

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'http://sinotruckcn.com/',
        },
      ],
    };
    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script3);

    return () => {
      if (document.head.contains(script1)) document.head.removeChild(script1);
      if (document.head.contains(script2)) document.head.removeChild(script2);
      if (document.head.contains(script3)) document.head.removeChild(script3);
    };
  }, []);

  return (
    <main>
      <Navbar />
      <HeroSection />
      <FeaturedGrid />
      <CategoryNav />
      <LatestUpdates />
      <AboutSection />
      <Testimonials />
      <CTASection />
      <Footer />
    </main>
  );
}